import axios from "axios"
import {getAxiosConfigWithAuth} from "../../utils/auth"

export const TabActionTypes = {
	OpenFinanceHistoryTab: "OPEN_FINANCE_HISTORY_TAB",
	OpenEventHistoryTab: "OPEN_EVENT_HISTORY_TAB",
	OpenCreditHistoryTab: "OPEN_CREDIT_HISTORY_TAB",
	OpenOrderFailuresTab: "OPEN_ORDER_FAILURES_TAB",
	LeaveEventHistoryTab: "LEAVE_EVENT_HISTORY_TAB",
}

export const ButtonActionTypes = {
	OpenTrackingUrl: "OPEN_TRACKING_URL",
	ClickCancelOrderButton: "CLICK_CANCEL_ORDER_BUTTON",
	ClickBackCancelOrderButton: "CLICK_BACK_CANCEL_ORDER_BUTTON",
	ClickRefundOrderButton: "CLICK_REFUND_ORDER_BUTTON",
	ClickBackRefundOrderButton: "CLICK_BACK_REFUND_ORDER_BUTTON",
	ClickCreditOrderButton: "CLICK_CREDIT_ORDER_BUTTON",
	ClickBackCreditOrderButton: "CLICK_BACK_CREDIT_ORDER_BUTTON",
	ClickReplaceOrderButton: "CLICK_REPLACE_ORDER_BUTTON",
	ClickBackReplaceOrderButton: "CLICK_BACK_REPLACE_ORDER_BUTTON",
	ClickOrderVoyagerButton: "CLICK_ORDER_VOYAGER_BUTTON",
	ClickSwitchItemViewButton: "CLICK_SWITCH_ITEM_VIEW_BUTTON",
	ClickCancelItemButton: "CLICK_CANCEL_ITEM_BUTTON",
	ClickCancelMultiSelectItemsButton: "CLICK_CANCEL_MULTI_SELECT_ITEMS_BUTTON",
	ClickBackCancelItemButton: "CLICK_BACK_CANCEL_ITEM_BUTTON",
	ClickBackCancelMultiSelectItemsButton: "CLICK_BACK_CANCEL_MULTI_SELECT_ITEMS_BUTTON",
	ClickRefundItemButton: "CLICK_REFUND_ITEM_BUTTON",
	ClickBackRefundItemButton: "CLICK_BACK_REFUND_ITEM_BUTTON",
	ClickCreditItemButton: "CLICK_CREDIT_ITEM_BUTTON",
	ClickBackCreditItemButton: "CLICK_BACK_CREDIT_ITEM_BUTTON",
	ClickReplaceItemButton: "CLICK_REPLACE_ITEM_BUTTON",
	ClickReplaceMultiSelectItemsButton: "CLICK_REPLACE_MULTI_SELECT_ITEMS_BUTTON",
	ClickBackReplaceItemButton: "CLICK_BACK_REPLACE_ITEM_BUTTON",
	ClickBackReplaceMultiSelectItemsButton: "CLICK_BACK_REPLACE_MULTI_SELECT_ITEMS_BUTTON",
	ClickCreditAndAddToCartButton: "CLICK_CREDIT_AND_ADD_TO_CART_BUTTON",
	ClickAddToCartButton: "CLICK_ADD_TO_CART_BUTTON",
	ClickAddToCartMultiSelectButton: "CLICK_ADD_TO_CART_MULTI_SELECT_BUTTON",
	ClickBackCreditAndAddToCartButton: "CLICK_BACK_CREDIT_AND_ADD_TO_CART_BUTTON",
	ClickBackAddToCartButton: "CLICK_BACK_ADD_TO_CART_BUTTON",
	ClickBackAddToCartMultiSelectButton: "CLICK_BACK_ADD_TO_CART_MULTI_SELECT_BUTTON",
	ClickDeleteAddToCartButton: "CLICK_DELETE_ADD_TO_CART_BUTTON",
	ClickDeleteCancelButton: "CLICK_DELETE_CANCEL_BUTTON",
	ClickDeleteReplaceButton: "CLICK_DELETE_REPLACE_BUTTON",
	ClickDeleteUpdateDocumentButton: "CLICK_DELETE_UPDATE_DOCUMENT_BUTTON",
	ClickUpdateDocumentButton: "CLICK_UPDATE_DOCUMENT_BUTTON",
	ClickUpdateDocumentMultiSelectButton: "CLICK_UPDATE_DOCUMENT_MULTI_SELECT_BUTTON",
	ClickBackUpdateDocumentButton: "CLICK_BACK_UPDATE_DOCUMENT_BUTTON",
	ClickBackUpdateDocumentMultiSelectButton: "CLICK_BACK_UPDATE_DOCUMENT_MULTI_SELECT_BUTTON",
	ClickEditShippingAddressButton: "CLICK_EDIT_SHIPPING_ADDRESS_BUTTON",
	ClickBackEditShippingAddressButton: "CLICK_BACK_EDIT_SHIPPING_ADDRESS_BUTTON",
	ClickEditBillingAddressButton: "CLICK_EDIT_BILLING_ADDRESS_BUTTON",
	ClickBackEditBillingAddressButton: "CLICK_BACK_EDIT_BILLING_ADDRESS_BUTTON",
	ClickEditItemButton: "CLICK_EDIT_ITEM_BUTTON",
	ClickOverPaymentConfirmYesButton: "CLICK_OVERPAYMENT_CONFIRM_YES_BUTTON",
	ClickMultiSelectRefundButton: "CLICK_MULTI_SELECT_REFUND_BUTTON",
	ClickMultiSelectRefundSubmitButton: "CLICK_MULTI_SELECT_REFUND_SUBMIT_BUTTON",
	ClickMultiSelectRefundCancelButton: "CLICK_MULTI_SELECT_REFUND_CANCEL_BUTTON",
	ClickMultiSelectCreditButton: "CLICK_MULTI_SELECT_CREDIT_BUTTON",
	ClickMultiSelectCreditSubmitButton: "CLICK_MULTI_SELECT_CREDIT_SUBMIT_BUTTON",
	ClickMultiSelectCreditCancelButton: "CLICK_MULTI_SELECT_CREDIT_CANCEL_BUTTON",
	ClickDocumentEditHistoryButton: "CLICK_DOCUMENT_EDIT_HISTORY_BUTTON",
	ClickReplacePreviousDocumentRevisionResetToOriginalButton:
		"CLICK_REPLACE_PREVIOUS_DOCUMENT_REVISION_RESET_TO_ORIGNAL_BUTTON",
	ClickReplacePreviousDocumentRevisionReplaceCurrentButton:
		"CLICK_REPLACE_PREVIOUS_DOCUMENT_REVISION_REPLACE_CURRENT_BUTTON",
	ClickReplacePreviousDocumentRevisionCancelButton:
		"CLICK_REPLACE_PREVIOUS_DOCUMENT_REVISION_CANCEL_BUTTON",
	HoverDisabledCreditItemToolTip: "HOVER_DISABLED_CREDIT_ITEM_TOOLTIP",
	HoverDisabledCreditOrderToolTip: "HOVER_DISABLED_CREDIT_ORDER_TOOLTIP",
}
export const ActionTypes = {
	DisableReplace: "DISABLE_REPLACE",
}

export const postActionLog = (actionData: any, caseId: string) => {
	axios
		.post(
			`${process.env.REACT_APP_CARE_ORDER_SERVICE}/v1/actionlogs?${
				caseId ? "caseId=" + caseId : ""
			}`,
			actionData,
			getAxiosConfigWithAuth()
		)
		.catch((err) => {
			console.log("error when loggin data", err)
		})
	return
}
